import { Link } from '@inertiajs/react';

interface BreadcrumbItem {
  name: string;
  url: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  currentPage: string;
}

export function Breadcrumbs({ items, currentPage }: BreadcrumbsProps) {
  return (
    <nav aria-label="Breadcrumb" className="mb-4">
      <ol
        itemScope
        itemType="https://schema.org/BreadcrumbList"
        className="flex flex-wrap items-center gap-1 text-xs text-gray-500"
      >
        {items.map((item, index) => (
          <li
            key={item.url}
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/ListItem"
            className="flex items-center gap-1"
          >
            {index > 0 && <span className="text-gray-300">›</span>}
            <Link
              href={item.url}
              itemProp="item"
              className="text-gray-500 hover:text-green-600 no-underline"
            >
              <span itemProp="name">{item.name}</span>
            </Link>
            <meta itemProp="position" content={String(index + 1)} />
          </li>
        ))}
        <li
          itemProp="itemListElement"
          itemScope
          itemType="https://schema.org/ListItem"
          className="flex items-center gap-1"
        >
          <span className="text-gray-300">›</span>
          <span itemProp="name" className="text-gray-700 font-medium">{currentPage}</span>
          <meta itemProp="position" content={String(items.length + 1)} />
        </li>
      </ol>
    </nav>
  );
}
